import { Container, Row, Col } from "react-bootstrap";
import openSourceData from "../data/open-source.json";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const OpenSource = () => {
  return (
    <section className="open-source" id="open-source">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Open Source</h2>
                  <p>Contributions grouped by organization</p>
                  <Row>
                    {openSourceData.map((item) => (
                      <Col key={item.org} lg={6} md={6} sm={12}>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          <div className="oss-card">
                            <span className="oss-tag">{item.tag}</span>
                            <h4>{item.org}</h4>
                            <p>{item.focus}</p>
                            <span className="oss-note">{item.contribution}</span>
                          </div>
                        </a>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
